import {IAugmentedJQuery, IComponentOptions, IController, IWindowService} from 'angular';
import './gmc-modal.component.scss';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {map, distinctUntilChanged} from 'rxjs/operators';
import {} from 'rxjs/operator/distinctUntilChanged';

export class GmcModalController implements IController {
  static $inject = [ '$element', '$window' ];
  backdrop: boolean;
  onClose: ( event ) => void;
  extraClasses = '';
  showBtn: boolean = true;
  isMobile: boolean = false;
  private timeoutId;
  constructor( private $element: IAugmentedJQuery, private $window: IWindowService ) {
  }

  $onInit() {
    this.isMobile = window.innerWidth < 800;
    if ( this.backdrop ) {
      this.timeoutId = setTimeout(() => {
        this.$element.on('click', ( event ) => {
          const target: any = event.target;
          if ( this.$element.is(target) ) {
            this.onClose({ result: 'backdrop', delay: 0 });
          }
        });
      }, 400);
    }

    setTimeout(() => {
      this.createBtn();
    }, 500);

    fromEvent(this.$element, 'scroll').pipe(
        map((event: JQueryEventObject) =>
            event.originalEvent.srcElement.scrollTop > this.$window.innerHeight
        ),
        distinctUntilChanged()
    ).subscribe((event) => {
      if (event) {
          this.$element.find('.top-button').removeClass('hide');
          this.$element.find('.top-button').addClass('show');
          return;
      }
      this.$element.find('.top-button').removeClass('show');
      this.$element.find('.top-button').addClass('hide');
    });

    fromEvent(window, 'resize').subscribe((res) => {
      this.createBtn();
    });

  }

  createBtn() {
    const modal: HTMLElement = this.$element.find('.modal-dialog')[0];
    if(!this.isMobile) {
    this.$element.find('.top-button').css('left', modal.offsetLeft + modal.clientWidth + 24);
    } else {
      this.$element.find('.top-button').css('left', modal.offsetLeft + modal.clientWidth - 55);
    }
  }

  $onDestroy() {
    if ( this.timeoutId ) {
      clearTimeout(this.timeoutId);
    }
  }

  scrollEvent() {

  }

  scrollTop() {
    this.$element.scrollTop(0);
  }
}

export const GmcModalComponent: IComponentOptions = {
  controller: GmcModalController,
  transclude: true,
  template: require('./gmc-modal.component.html'),
  bindings: {
    extraClasses: '<?',
    backdrop: '<',
    showBtn: '<',
    onClose: '&',
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/gmc-modal/gmc-modal.component.ts